import Database from "../lib/database";
import { Actions } from "../types";
import * as environment from "./environment";

export const db = new Database({
  dbName: "sso-sdk",
  dbVersion: 1,
  storeName: "credentials",
});

export const ssoClientUrl = environment?.ssoClientUrl;
export const ssoServerUrl = environment?.ssoServerUrl;

export const actions = {
  local_login: "local-login",
  local_register: "local-register",
  local_logout: "local-logout",
  local_exchange: "local-exchange",
  sso_exchange: "sso-exchange",
  logout: "logout",
  session_cleared: "session-cleared",
  refresh: "refresh",
  profile_fetch: "profile.fetch",
  profile_update: "profile.update",
  profile_photo_update: "profile-photo.update",
  cloth_add: "cloth.add",
  cloth_fetch_all: "cloth.fetch-all",
  cloth_fetch: "cloth.fetch",
  cloth_update: "cloth.update",
  cloth_delete: "cloth.delete",
  material_add: "material.add",
  material_fetch_all: "material.fetch-all",
  material_fetch: "material.fetch",
  material_update: "material.update",
  material_delete: "material.delete",
  skull_add: "skull.add",
  skull_update: "skull.update",
  skull_fetch_all: "skull.fetch-all",
  skull_fetch: "skull.fetch",
  skull_delete: "skull.delete",
  skull_material_add: "skull-material.add",
  skull_material_fetch_all: "skull-material.fetch-all",
  skull_material_fetch: "skull-material.fetch",
  skull_material_update: "skull-material.update",
  skull_material_delete: "skull-material.delete",
  body_add: "body.add",
  body_fetch_all: "body.fetch-all",
  body_fetch: "body.fetch",
  body_update: "body.update",
  body_delete: "body.delete",
} satisfies Record<string, Actions["type"]>;
